import { render, staticRenderFns } from "./Logovanje.vue?vue&type=template&id=9839f036"
import script from "./Logovanje.vue?vue&type=script&lang=js"
export * from "./Logovanje.vue?vue&type=script&lang=js"
import style0 from "./Logovanje.vue?vue&type=style&index=0&id=9839f036&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports